import * as dayjs from 'dayjs';
import { DurationUnitType } from 'dayjs/plugin/duration';

export const formatDuration = (time: number, unit?: DurationUnitType, format = 'mm:ss') => {
  return dayjs.duration(time, unit).format(format);
};

export const formatDurationAuto = (seconds: number) => {
  return seconds >= 3600
    ? formatDuration(seconds, 's', 'HH:mm:ss')
    : formatDuration(seconds, 's', 'mm:ss');
};
